import { useAuth } from "@/features/auth/hooks/use-auth";

interface SectionHeaderProps {
  title: string;
  description: string;
}

export function SectionHeader({ title, description }: SectionHeaderProps) {
  const { user } = useAuth();

  return (
    <div className="lg:sticky lg:top-0 z-20 bg-white dark:bg-gray-800">
      <div className="flex items-center justify-between h-20 px-6 lg:px-8 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{title}</h1>
          <p className="text-xs text-gray-500 dark:text-gray-400">{description}</p>
        </div>
        <div className="hidden lg:flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-primary-100 dark:bg-primary-900 flex items-center justify-center text-primary-700 dark:text-primary-300 font-semibold text-sm flex-shrink-0">
            {user?.firstName?.charAt(0).toUpperCase() || "U"}
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium text-gray-900 dark:text-gray-100 leading-tight">
              {user?.firstName} {user?.lastName}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 leading-tight">{user?.email}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
